import { PlatformDependencies } from './platformDependencies';
import { resolveFromGlobal } from './resolveFromGlobal';

/**
 * @category Platform Dependency
 */
export type ShowModal = (modalToRender: JSX.Element) => void;

/**
 * @category Platform Dependency
 */
export const showModal: ShowModal = modalToRender => {
	return resolveFromGlobal(PlatformDependencies.ShowModal)(modalToRender);
};
